import api from './api';

export const authService = {
  login: async (email, password, empresaId = null) => {
    try {
      const payload = {
        correo: email,
        contrasena: password,
      };
      
      if (empresaId) {
        payload.empresaID = empresaId;
      }

      const response = await api.post('/auth/login', payload);
      
      if (response.success && response.data) {
        // Usar sessionStorage en lugar de localStorage para que la sesión se pierda al cerrar el navegador
        // Store user data (the API doesn't return a token yet, we'll use a dummy for now)
        // TODO: Implement JWT token generation in the backend
        sessionStorage.setItem('token', 'dummy-token');
        // Guardar los datos del usuario tal como vienen del API
        sessionStorage.setItem('user', JSON.stringify(response.data));
      }
      
      return response;
    } catch (error) {
      // Re-throw the error so it can be handled by the caller
      throw error;
    }
  },

  logout: () => {
    // Limpiar tanto sessionStorage como localStorage por si acaso
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = sessionStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!sessionStorage.getItem('token');
  },
};

